import { useEffect } from "react";
import { useBlocker } from "react-router";

import CommonAlert from "@/components/CommonAlert";

function Blocker({ shouldBlock }: { shouldBlock: boolean }) {
    let blocker = useBlocker(
        ({ currentLocation, nextLocation }) => shouldBlock && currentLocation.pathname !== nextLocation.pathname
    );

    const isBlocked = blocker?.state === "blocked";
    const handleClose = () => {
        if (isBlocked) {
            blocker.reset();
        }
    };
    const handleConfirm = () => {
        if (isBlocked) {
            blocker.proceed();
        }
    };

    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent): string | void => {
            if (shouldBlock) {
                event.preventDefault(); // Prevent the default browser behavior (e.g., direct navigation)
                event.returnValue = ""; // This line triggers the browser's warning message in most browsers
                return ""; // Also needed for some older browsers (e.g., IE) to show the warning
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [shouldBlock]);

    return (
        <CommonAlert
            open={isBlocked}
            loading={false}
            description="confirmations.changePageWhileEditing"
            color="primary"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{}}
            confirmText="buttons.cancelStayAtPage"
            cancelText="buttons.stayAtPage"
        ></CommonAlert>
    );
}

export default Blocker;
